import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { OportunitiesService } from 'src/app/services/oportunities.service';
import { LIST_OPORTUNITIES_COLUMN } from 'src/app/shared/data/data';
import { Oportunitie, RequestStatus } from 'src/app/shared/data/models';
import { SubSink } from 'subsink';
import { DeleteOportComponent } from '../delete-oport/delete-oport.component';
import { tap } from 'rxjs';

@Component({
  selector: 'app-list-oportunities',
  templateUrl: './list-oportunities.component.html',
  styleUrls: ['./list-oportunities.component.scss'],
})
export class ListOportunitiesComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy
{
  @Input() public valueFilter: string;
  @Input() public menuChange: boolean;
  @Output() public totalValues = new EventEmitter<number>();
  private subs = new SubSink();
  public dataTable: any[] = [];
  private page: number = 1;
  private limit: number = 10;
  public totalItemsList: number = 0;
  public displayedColumns = LIST_OPORTUNITIES_COLUMN;
  public dataSource = new MatTableDataSource([]);
  @ViewChild(MatPaginator) public paginator: MatPaginator;
  public itemsPerPage: number = 10;
  public statusDetail: RequestStatus = 'init';
  constructor(
    private dialog: MatDialog,
    private oportuniti: OportunitiesService,
    private router: Router
  ) {}

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  ngOnInit(): void {
    this.listOportunities(this.page, this.limit);
    this.oportuniti.Refreshrequired.subscribe(() => {
      this.listOportunities(this.page, this.limit);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.dataSource.filter = this.valueFilter === 'all' ? '' : this.valueFilter;
  }

  public listOportunities(page: number, limit: number): void {
    this.subs.sink = this.oportuniti
      .getListOportunities(page, limit)
      .pipe(tap(() => (this.statusDetail = 'success')))
      .subscribe((resp: any) => {
        const { find, totalItems } = resp;
        this.totalItemsList = totalItems;
        this.sendTotalItemsList(totalItems);
        const newLisWithBetterDate: any = [];
        find.forEach((element: any) => {
          newLisWithBetterDate.push({
            ...element,
            created_At: this.changeDate(element.created_At),
            picture: element.file,
          });
        });
        this.dataTable = newLisWithBetterDate;
        this.dataSource.data = newLisWithBetterDate;
      });
  }

  public openDialogDelete(id: string): void {
    this.dialog.open(DeleteOportComponent, {
      width: '456px',
      height: '208px',
      disableClose: true,
      data: {
        idOport: id,
      },
    });
  }

  public goToEditOportunitie(id: string): void {
    this.router.navigate([`oport/edit-oportunities/${id}`]);
  }

  private changeDate(date: any): string {
    let schedule = new Date(date);
    schedule.setSeconds(0, 0);
    let schedule2 = schedule.toLocaleString().replace(/,/, ' - ');
    return schedule2.toLocaleString().replace(/:00/, '');
  }

  public sortingByTitle() {
    let newOrder = this.dataSource.data.sort(
      (a: Oportunitie, b: Oportunitie) => {
        const nameA = a.opportunity_title.toUpperCase();
        const nameB = b.opportunity_title.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      }
    );
    this.dataSource.data = newOrder;
  }

  public sortByTitledown(): any {
    let newOrder = this.dataSource.data.sort(
      (a: Oportunitie, b: Oportunitie) => {
        const nameA = a.opportunity_title.toUpperCase();
        const nameB = b.opportunity_title.toUpperCase();
        if (nameA > nameB) {
          return -1;
        }
        if (nameA < nameB) {
          return 1;
        }
        return 0;
      }
    );
    this.dataSource.data = newOrder;
  }

  public sortByUpTipe(): any {
    let newOrder = this.dataSource.data.sort((a: any, b: any) => {
      const nameA = a.type.toUpperCase();
      const nameB = b.type.toUpperCase();
      if (nameA > nameB) {
        return -1;
      }
      if (nameA < nameB) {
        return 1;
      }
      return 0;
    });
    this.dataSource.data = newOrder;
  }

  public sortByDownTipe(): any {
    let newOrder = this.dataSource.data.sort((a: any, b: any) => {
      const nameA = a.type.toUpperCase();
      const nameB = b.type.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
    this.dataSource.data = newOrder;
  }

  public sendTotalItemsList(value: number): void {
    this.totalValues.emit(value);
  }
}
